import { useLocation, useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { nextPage, dataChange, backPage, nowPage, orderNoPush, memoPush, PDorderAssignType, PDcardDataInsert, cardDataInsert } from '../slices/counterSlice';
import { useEffect, useRef, useState } from "react";
import { getPrice, addorder } from "../api/order"
import CircularProgress from '@mui/material/CircularProgress';
import mixpanel from "mixpanel-browser";

const ContentFrame = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 80px;
  padding-top: 40px;
`;

const SubContentFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media (max-width: 1099px) {
    gap: 10px;
  }
`;

const SubTitleFrame = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
  @media (max-width: 1099px) {
    gap: 0px;
  }
`;

const SubTitle = styled.div`
  font-family: Gongim-Medium;
  font-size: 32px;
  @media (max-width: 1099px) {
    font-size: 18px;
  }
`;

const PayTitle = styled.div`
  font-family: Gongim-Medium;
  font-size: 32px;
  @media (max-width: 1099px) {
    font-size: 28px;
  }
`;
const RedTitle = styled.div`
  font-family: Gongim-Reguler;
  font-size: 13px;
  color: #eb3f3d;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 10px;
  }
`;

const TableFrame = styled.div`
  display: flex;
  flex-direction: column;
  border-top: solid 2px #99a5ac;
  box-sizing: content-box;
`;

const TableRow = styled.div`
  width: 100%;
  border-bottom: solid 2px #ddd;
  box-sizing: content-box;
  padding: 28px 0;
  display: flex;
  justify-content: start;
  gap: 80px;
  @media (max-width: 1099px) {
    gap: 40px;
  }

  @media (max-width: 767px) {
    border-bottom: none;
    flex-direction: column;
    padding: 0;
  }
`;
const TableGroup = styled.div`
  width: 510px;
  display: flex;
  justify-content: start;
  align-items: center;
  @media (max-width: 1099px) {
    width: 100%;
  }
  @media (max-width: 767px) {
    padding: 28px 0;
    border-bottom: solid 2px #ddd;
    flex: 1;
  }
`;

const TableLeftTitle = styled.div`
  width: 150px;
  font-family: Gongim-Medium;
  font-size: 20px;
  text-align: left;
  color: #333;
  @media (max-width: 1099px) {
    word-wrap: break-word;
    width: 104px;

    font-size: 16px;
  }
`;

const RightRowFrame = styled.div`
  display: flex;

  flex: 1;
`;

const LeftColFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  @media (max-width: 1099px) {
    gap: 4px;
  }
`;

const RightColFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  @media (max-width: 1099px) {
    gap: 10px;
  }
`;

const RightColFrameMini = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const RightMedium = styled.div`
  font-family: Gongim-Medium;
  font-size: 18px;
  color: #333;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;
const RightMedium86px = styled.div`
  width: 86px;
  font-family: Gongim-Medium;
  font-size: 18px;
  color: #333;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 15px;
    width: 72px;
  }
`;

const RightReguler = styled.div`
  font-family: Gongim-Reguler;
  font-size: 18px;
  color: #333;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;

const RightRegulerMini = styled.div`
  font-family: Gongim-Reguler;
  font-size: 16px;
  color: #707070;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 12px;
  }
`;

const TextInfut = styled.input`
  width: 80px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #707070;
  color: #333;
  font-family: Gongim-Medium;
  font-size: 16px;
  text-align: center;
  @media (max-width: 1099px) {
    height: 36px;
    width: 30px;
    flex: 1;
    font-size: 14px;
    padding: 0 12px;
  }
`;

const TextArea = styled.textarea`
  height: 40px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  flex: 1;
  display: flex;
  height: auto;
  min-height: 40px;
  border: 1px solid #707070;
  color: #333;
  font-family: Gongim-Medium;
  font-size: 16px;
  line-height: 160%;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 14px;
  }
`;

const WordSkip = styled.div`
  @media (min-width: 1100px) {
    display: none;
  }
`;
const ButtonLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 0 0 80px 0;
  @media (max-width: 1099px) {
    gap: 10px;
    padding: 36px 0;
  }
`;

const ButtonRed = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eb3f3d;
  color: #fff;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  ${(props) =>
    props.disable === true ?
      css`
      background-color: #999;
      color: #fff;
    ` :
      css`
      background-color: #eb3f3d;
      color: #fff;
    `
  }
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

const ButtonBack = styled.div`
  width: 230px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #707070;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  color: #707070;
  font-family: Gongim-Medium;
  font-size: 20px;
  cursor: pointer;
  @media (max-width: 1099px) {
    flex: 1;
    height: 40px;
    font-size: 18px;
  }
`;

const LoadingWrapper = styled.div`
  width: 100%;
  height: 100px;
  text-align: center
`;

const BackgroundBlack = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
`

const PricePopup = styled.div`
  padding: 36px 20px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 800px;
  height: 500px;
  background: #FFFFFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 1099px) {
    width: 480px;
    height: 480px;
  }
  @media (max-width: 767px) {
    height: 100%;
    width: 100%;
  }
`

const PopupWrapper = styled.div`
  width: 100%;
  height: 480px;
  text-align: left;
  overflow-y: scroll;
  @media (max-width: 767px) {
    height: 100%;
    width: 100%;
  }
`

const PopupText = styled.p`
  font-size: 18px;
  padding-top: 36px;
  margin: 0;
  margin-bottom: 10px;
  font-family: Gongim-Medium;
  @media (max-width: 1099px) {
    font-size: 16px;
  }
`

const DefaultPriceTable = styled.table`
  width: 100%;
  border-collapse : collapse
`;

const TableHead = styled.th`
  height: 66px;
  padding: 10px 0px;
  gap: 4px;
  border-bottom: 1px solid #707070;
  text-align: center;
  background-color: #F8F8F8;
  font-family: Gongim-Reguler;
  font-size: 18px;
  width: 20%;
  border-top: 2px solid #707070;
  align-items: center;
  text-align: center;
  line-height: 130%;
`
const TableData = styled.td`
  font-family: Gongim-Reguler;
  height: 43px;
  border-bottom: 1px solid #DDD;
  text-align: center;
  align-item: center;
  gap: 4px;
  font-size: 18px;
  @media (max-width: 1099px) {
    font-size: 16px;
  }
`



export default function Content03() {
  const [loading, setLoading] = useState(false);
  const [distance, setDistance] = useState('');
  const [systemPrice, setSystemPrice] = useState('');
  const [pdSystemPrice, setPdSystemPrice] = useState(0);
  const [assignText, setAssignText] = useState('');
  const [disableBtn, setDisableBtn] = useState(true);
  const [totalPrice, setTotalPrice] = useState(0);

  const [num1, setNum1] = useState('');
  const [num2, setNum2] = useState('');
  const [num3, setNum3] = useState('');
  const [num4, setNum4] = useState('');

  const [yy, setYy] = useState('');
  const [mm, setMm] = useState('');

  const [cardYear, setCardYear] = useState('');
  const [cardNum, setCardNum] = useState('');

  const [memo, setMemo] = useState('');

  const [popup, setPopup] = useState(false);


  // // 요금 상세내역 계산 변수
  // const [emergency, setEmergency] = useState(0);
  // const [outBack, setOutBack] = useState(0);
  // const [danger, setDanger] = useState(0);
  //
  // //픽업&딜리버리 요금 상세내역 계산 변수
  // const [pdEmergency, setPdEmergency] = useState(0);
  // const [pdOutBack, setPdOutBack] = useState(0);
  // const [pdDanger, setPdDanger] = useState(0);


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const path = useLocation();
  let data = useSelector((state) => state.counter.data.data);
  let PDdata = useSelector((state) => state.counter.data.PDdata);
  let fin = useSelector((state) => state.counter.data.complate);
  let no = useSelector((state) => state.counter.data.orderNo);
  let PD = useSelector((state) => state.counter.data.assignType);


  if (fin === true) {
    window.location.replace('/fin')
  }

  dispatch(nowPage(path.pathname));
  dispatch(memoPush(memo));

  // useEffect(() => {
  //   detailPrice();
  // }, [])

  useEffect(() => {
    price();
  }, [])

  useEffect(() => { // 카드번호 길이 변경 예상됨
    setCardNum(num1 + " " + num2 + " " + num3 + " " + num4);
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    const valiYear = String(year).substring(2, 4)

    if (Number(valiYear) <= yy && mm != '00' && mm < 13 && num1.length >= 4 && num2.length >= 4 && num3.length >= 4 && num3.length >= 4 && num4.length >= 4 && yy.length >= 2 && mm.length >= 2) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [num1, num2, num3, num4])

  useEffect(() => {
    setCardYear(mm + "/" + yy);
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    const valiYear = String(year).substring(2, 4)

    if (Number(valiYear) <= yy && mm != '00' && mm < 13 && num1.length >= 4 && num2.length >= 4 && num3.length >= 4 && num3.length >= 4 && num4.length >= 4 && yy.length >= 2 && mm.length >= 2) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [mm, yy])

  const params = {
    callType: 4,
    user: {
      type: 2,
      id: '0',
      name: '',
      phoneNo: data.user.phoneNo,
      branchCode: '',
      deptName: '',
      checkType: 2
    },
    productType: 2,
    productServiceType: 1,
    routes: [
      {
        locationName: '',
        phoneNo: '',
        addr: data.routes[0].addr,
        addrDetail: data.routes[0].addrDetail,
        lat: data.routes[0].lat,
        lon: data.routes[0].lon,
      },
      {
        locationName: '',
        phoneNo: '',
        addr: data.routes[1].addr,
        addrDetail: data.routes[1].addrDetail,
        lat: data.routes[1].lat,
        lon: data.routes[1].lon,
      }
    ]
  }
  const PDparams = {
    callType: 4,
    user: {
      type: 2,
      id: '0',
      name: '',
      phoneNo: PDdata.user.phoneNo,
      branchCode: '',
      deptName: '',
      checkType: 2
    },
    productType: 2,
    productServiceType: 1,
    routes: [
      {
        locationName: '',
        phoneNo: '',
        addr: PDdata.routes[0].addr,
        addrDetail: PDdata.routes[0].addrDetail,
        lat: PDdata.routes[0].lat,
        lon: PDdata.routes[0].lon,
      },
      {
        locationName: '',
        phoneNo: '',
        addr: PDdata.routes[1].addr,
        addrDetail: PDdata.routes[1].addrDetail,
        lat: PDdata.routes[1].lat,
        lon: PDdata.routes[1].lon,
      }
    ]
  }

  //
  // const detailPrice = () => {
  //   /*
  //     긴급배차 확인 여부 -> 현재시각이랑 현재시각+3 사이에 예약을 했을때 진행 그러면 시간이 문자열로 되어있으니 int 형으로 변경하여 계산을 진행
  //     오지요금 -> 출 / 도착지 중 아무곳에 (읍/면/리) 포함시 10,000 포함 주소쪽 필드 확인 여부 필요
  //     배차 취약시간 -> 예약시간 기준 오후4시 부터 다음날 오전9시 까지를 계산해야
  //   */
  //   const date1 = new Date();
  //
  //   const nowHour = date1.getHours();
  //   const reservationDate = data.reservationDate.split(" ")[0];
  //   const reservationTime = data.reservationDate.split(" ")[1];
  //   const PDreservationDate = PDdata.reservationDate !== "" ? PDdata.reservationDate.split(" ")[0] : "";
  //   const PDreservationTime = PDdata.reservationDate !== "" ? PDdata.reservationDate.split(" ")[1] : "";
  //   // console.log(date1.toISOString().split("T")[0]);
  //
  //
  //   // 긴급 배차 조건
  //   if (date1.toISOString().split("T")[0] === reservationDate) {
  //     // console.log(nowHour+3, Number(reservationTime.split(":")[0]))
  //     if ((nowHour + 3) >= Number(reservationTime.split(":")[0])) {
  //       setEmergency(10000);
  //     }
  //   }
  //   if (date1.toISOString().split("T")[0] === PDreservationDate) {
  //     if ((nowHour + 3) >= Number(PDreservationTime.split(":")[0])) {
  //       setPdEmergency(10000);
  //     }
  //   }
  //
  //   // 오지 요금 조건
  //   const SendAddArray = data.routes[0].addr.split(" ");
  //   const EndAddArray = data.routes[1].addr.split(" ");
  //   const PDsendAddArray = PDdata.routes[0].addr !== "" ? PDdata.routes[0].addr.split(" ") : "";
  //   const PDendAddArray = PDdata.routes[1].addr ? PDdata.routes[1].addr.split(" ") : "";
  //
  //   if (PD === 2) { // 픽업&딜리버리 오지 요금 조건
  //     for (let i = 0; i < SendAddArray.length; i++) {
  //       if (SendAddArray[i].substring(SendAddArray[i].length - 1) === '읍' || SendAddArray[i].substring(SendAddArray[i].length - 1) === '면' || SendAddArray[i].substring(SendAddArray[i].length - 1) === '리') {
  //         // setOutBack(20000);
  //         setOutBack(10000);
  //       }
  //     };
  //     for (let i = 0; i < EndAddArray.length; i++) {
  //       if (EndAddArray[i].substring(EndAddArray[i].length - 1) === '읍' || EndAddArray[i].substring(EndAddArray[i].length - 1) === '면' || EndAddArray[i].substring(EndAddArray[i].length - 1) === '리') {
  //         // setOutBack(20000);
  //         setOutBack(10000);
  //       }
  //     };
  //     for (let i = 0; i < PDsendAddArray.length; i++) {
  //       if (PDsendAddArray[i].substring(PDsendAddArray[i].length - 1) === '읍' || PDsendAddArray[i].substring(PDsendAddArray[i].length - 1) === '면' || PDsendAddArray[i].substring(PDsendAddArray[i].length - 1) === '리') {
  //         // setOutBack(20000);
  //         setPdOutBack(10000);
  //       }
  //     };
  //     for (let i = 0; i < PDendAddArray.length; i++) {
  //       if (PDendAddArray[i].substring(PDendAddArray[i].length - 1) === '읍' || PDendAddArray[i].substring(PDendAddArray[i].length - 1) === '면' || PDendAddArray[i].substring(PDendAddArray[i].length - 1) === '리') {
  //         // setOutBack(20000);
  //         setPdOutBack(10000);
  //       }
  //     };
  //   } else { // 픽업 or 딜리버리 오지요금 조건
  //     for (let i = 0; i < SendAddArray.length; i++) {
  //       if (SendAddArray[i].substring(SendAddArray[i].length - 1) === '읍' || SendAddArray[i].substring(SendAddArray[i].length - 1) === '면' || SendAddArray[i].substring(SendAddArray[i].length - 1) === '리') {
  //         setOutBack(10000);
  //       }
  //     };
  //     for (let i = 0; i < EndAddArray.length; i++) {
  //       if (EndAddArray[i].substring(EndAddArray[i].length - 1) === '읍' || EndAddArray[i].substring(EndAddArray[i].length - 1) === '면' || EndAddArray[i].substring(EndAddArray[i].length - 1) === '리') {
  //         setOutBack(10000);
  //       }
  //     };
  //   }
  //   // 배차 취약 시간 조건
  //   const reservationTimeHour = data.reservationDate.split(" ")[1].split(":")[0];
  //   const reservationTimeMin = data.reservationDate.split(" ")[1].split(":")[1];
  //
  //   const PDreservationTimeHour = PDdata.reservationDate !== "" ? PDdata.reservationDate.split(" ")[1].split(":")[0] : "";
  //   const PDreservationTimeMin = PDdata.reservationDate !== "" ? PDdata.reservationDate.split(" ")[1].split(":")[1] : "";
  //
  //   if (PD === 2) {
  //     if ((9 >= Number(reservationTimeHour) && 30 !== Number(reservationTimeMin)) || 9 > Number(reservationTimeHour)) {
  //       setDanger(5000);
  //     } else if ((16 <= Number(reservationTimeHour) && 30 === Number(reservationTimeMin)) || 16 <= Number(reservationTimeHour)) {
  //       setDanger(5000);
  //     } else {
  //       setDanger(0);
  //     }
  //     if ((9 >= Number(PDreservationTimeHour) && 30 !== Number(PDreservationTimeMin)) || 9 > Number(PDreservationTimeHour)) {
  //       setPdDanger(5000);
  //     } else if ((16 <= Number(PDreservationTimeHour) && 30 === Number(PDreservationTimeMin)) || 16 <= Number(PDreservationTimeHour)) {
  //       setPdDanger(5000);
  //     } else {
  //       setPdDanger(0);
  //     }
  //   } else {
  //     if ((9 === Number(reservationTimeHour) && 30 !== Number(reservationTimeMin)) || 9 > Number(reservationTimeHour)) {
  //       setDanger(5000);
  //     } else if ((16 <= Number(reservationTimeHour) && 30 === Number(reservationTimeMin)) || 16 <= Number(reservationTimeHour)) {
  //       setDanger(5000);
  //     } else {
  //       setDanger(0);
  //     }
  //   }
  // }

  const replacePrice = (str) => {
    const comma = (str) => {
      str = String(str);
      return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
    };
    const uncomma = (str) => {
      str = String(str);
      return str.replace(/[^\d]+/g, "");
    };
    return comma(uncomma(str));
  }


  async function price() {
    setLoading(true);

    if (PD === 2) {
      await getPrice(params).then(async (res) => {
        await getPrice(PDparams).then(response => {
          if (data.routes[0].car.brand === '외산') {
            // setSystemPrice(res.data.payLoad.systemPrice + response.data.payLoad.systemPrice + 4000);
            setSystemPrice(res.data.payLoad.systemPrice + 2000);
            setPdSystemPrice(response.data.payLoad.systemPrice + 2000);
          } else {
            // setSystemPrice(res.data.payLoad.systemPrice + response.data.payLoad.systemPrice);
            setSystemPrice(res.data.payLoad.systemPrice);
            setPdSystemPrice(response.data.payLoad.systemPrice);
          }
          setDistance(res.data.payLoad.distance + response.data.payLoad.distance);
        })
        if (data.assignType === 1 && PD === 0) {
          setAssignText('픽업');
        } else if (PD === 2) {
          setAssignText('픽업&딜리버리');
        } else if (data.assignType === 3 && PD === 0) {
          setAssignText('딜리버리');
        }
        setLoading(false);
      })
    } else {
      await getPrice(params).then(res => {
        if (data.routes[0].car.brand === '외산') {
          setSystemPrice(res.data.payLoad.systemPrice + 2000);
        } else {
          setSystemPrice(res.data.payLoad.systemPrice);
        }
        setDistance(res.data.payLoad.distance);
        if (data.assignType === 1 && PD === 0) {
          setAssignText('픽업');
        } else if (PD === 2) {
          setAssignText('픽업&딜리버리');
        } else if (data.assignType === 3 && PD === 0) {
          setAssignText('딜리버리');
        }
        setLoading(false);
      })
    }
  }

  if (data.user.phoneNo === '') {
    window.location.replace('/')
  }

  const nextPage = async () => {
    if (disableBtn === false) {
      const params = {
        ...data,
        // payAmount: data.routes[0].car.brand === '외산' ? (systemPrice + emergency + outBack + danger + 2000) : (systemPrice + emergency + outBack + danger),
        // payAmount: (systemPrice + emergency + outBack + danger),
        // remark: `{ 기본요금:${systemPrice}, 긴급배차:${emergency}, 오지요금:${outBack}, 배차취약시간:${danger} }`,
        payAmount: systemPrice,
        transNo: `GONGIM-${Date.now()}`
      };
      const PDparams = {
        ...PDdata,
        // payAmount: data.routes[0].car.brand === '외산' ? (systemPrice + emergency + outBack + danger + 2000) : (systemPrice + emergency + outBack + danger),
        // payAmount: (systemPrice + emergency + outBack + danger),
        // payAmount: (pdSystemPrice + pdEmergency + pdOutBack + pdDanger),
        // remark: `{ 기본요금:${pdSystemPrice}, 긴급배차:${pdEmergency}, 오지요금:${pdOutBack}, 배차취약시간:${pdDanger} }`,
        payAmount: pdSystemPrice,
        transNo: `GONGIM-${Date.now() + 1}`
      }
      if (PD === 2) { // 픽업&딜리버리 오더 접수
        await addorder(params).then(res => {  // 픽업 오더 접수 api
          dispatch(orderNoPush(res.data.payLoad.orderNo));
          dispatch(cardDataInsert({
            orderNo: res.data.payLoad.orderNo,
            cn: cardNum,
            cexm: Number(mm),
            cexy: Number(yy)
          }))
          mixpanel.track("오더 접수버튼 클릭");
          navigate('/fin');
        }).catch(err => {
          console.log(err)
        })
        await addorder(PDparams).then(res => {  // 딜리버리 오더 접수 api
          dispatch(orderNoPush(res.data.payLoad.orderNo));
          dispatch(PDcardDataInsert({
            orderNo: res.data.payLoad.orderNo,
            cn: cardNum,
            cexm: Number(mm),
            cexy: Number(yy)
          }))
          mixpanel.track("오더 접수버튼 클릭");
          navigate('/fin');
        }).catch(err => {
          console.log(err)
        })

      } else {
        await addorder(params).then(res => {  // 오더 접수 api
          dispatch(orderNoPush(res.data.payLoad.orderNo));
          dispatch(cardDataInsert({
            orderNo: res.data.payLoad.orderNo,
            cn: cardNum,
            cexm: Number(mm),
            cexy: Number(yy)
          }))
          mixpanel.track("오더 접수버튼 클릭");
          navigate('/fin');
        }).catch(err => {
          console.log(err)
        })
      }
    } else {
      const year = new Date().getFullYear();
      const month = new Date().getMonth() + 1;
      const valiYear = String(year).substring(2, 4);
      console.log(month, mm);
      if (mm >= 13 || mm == '00') {
        alert("결제(유효기간)의 월 은 1 ~ 12월 까지 입력 가능합니다.");
      } else if (cardNum === '' || mm === '' || yy === '') {
        alert("카드 정보를 입력해주세요.");
      } else if (mm === '' || yy === '') {
        alert("결제 유효기간을 입력해주세요.");
      } else if (cardNum === '') {
        alert("카드 번호를 입력해주세요.");
      } else if (Number(valiYear) > yy) {
        alert("카드 유효기간이 잘못되었습니다.");
      } else if (num1.length < 4 || num2.length < 4 || num3.length < 4 || num4.length < 4) {
        alert("카드번호를 전부 입력해주세요.");
      }
      // console.log(cardNum + "  " + cardYear);
    }
  }


  return (
    <ContentFrame>
      {loading &&
        <LoadingWrapper>
          <CircularProgress />
        </LoadingWrapper>
      }
      {!loading &&
        <>
          <SubContentFrame>
            <SubTitleFrame>
              <SubTitle>결제 및 특이사항 입력</SubTitle>
              <RedTitle>결제는 최종 운행 완료 이후에 진행됩니다.</RedTitle>
            </SubTitleFrame>
            <TableFrame>
              <TableRow>
                <TableGroup>
                  <TableLeftTitle>운행거리</TableLeftTitle>
                  <RightRowFrame>
                    <RightMedium>{distance}km</RightMedium>
                    <RightReguler>({assignText})</RightReguler>
                  </RightRowFrame>
                </TableGroup>
                <TableGroup>
                  <TableLeftTitle style={{ width: '45%' }}>
                    결제 예상 요금
                    <RedTitle style={{ paddingTop: '5px' }}>
                      대기/경유/취소/부가업무 발생시
                      <br /> 추가 요금이 발생 될 수 있습니다.
                    </RedTitle>
                  </TableLeftTitle>
                  <RightRowFrame style={{ display:'block', marginBottom: '10px' }}>
                    <PayTitle style={{ display: 'flex' }}>
                      {replacePrice(systemPrice) }
                      <RightMedium style={{ paddingTop: '15px' }}>원</RightMedium>
                      {/*<button>+</button><button>-</button>*/}
                    </PayTitle>
                    <RedTitle>
                      ※ 추천 요금으로 기사배정이  원활하지 않을 경우
                      가격이 조정될 수 있습니다. (상담원 통화 후 협의)
                    </RedTitle>
                  </RightRowFrame>
                </TableGroup>
              </TableRow>
              <TableRow>
                <TableGroup style={{ display:'block', width: '100%' }}>
                  <SubTitle style={{ width:'100%', marginTop: '40px'  ,textAlign: 'left' }}>공임나라 x YWMobile 딜리버리 가격 안내</SubTitle>
                  <PopupText style={{ textAlign: 'left' }}>기본 요금 (5Km 기준)</PopupText>
                  <DefaultPriceTable>
                    <tr>
                      <TableHead>차종</TableHead>
                      <TableHead>기본 요금</TableHead>
                      <TableHead>기본 운행 거리 <br />초과 요금</TableHead>
                    </tr>
                    <tr>
                      <TableData>국산차</TableData>
                      <TableData>18,000원</TableData>
                      <TableData>700원 / Km</TableData>
                    </tr>
                    <tr>
                      <TableData>수입차</TableData>
                      <TableData>20,000원</TableData>
                      <TableData>700원 / Km</TableData>
                    </tr>
                  </DefaultPriceTable>
                  <RedTitle style={{ textAlign: 'right', marginTop: '20px' }}>※ 요금은 1,000원 단위로 반올림 됩니다.</RedTitle>
                  <PopupText style={{ textAlign: 'left', paddingTop: '8px' }}>부가 요금</PopupText>
                  <DefaultPriceTable>
                    <tr>
                      <TableHead style={{ height: '43px' }}>항목</TableHead>
                      <TableHead style={{ height: '43px' }}>요금</TableHead>
                      <TableHead style={{ height: '43px' }}>비고</TableHead>
                    </tr>
                    <tr>
                      <TableData>대기</TableData>
                      <TableData>5,000 / 30분</TableData>
                      <TableData>-</TableData>
                    </tr>
                    {/*<tr>*/}
                    {/*  <TableData>경유</TableData>*/}
                    {/*  <TableData>1,000 / Km</TableData>*/}
                    {/*  <TableData>-</TableData>*/}
                    {/*</tr>*/}
                    <tr>
                      <TableData>취소</TableData>
                      <TableData>10,000 / 건</TableData>
                      <TableData>기사 배차 후 취소시</TableData>
                    </tr>
                    <tr>
                      <TableData>부가업무</TableData>
                      <TableData>10,000 / 건</TableData>
                      <TableData>서류 처리, 주유, 세차</TableData>
                    </tr>
                  </DefaultPriceTable>
                </TableGroup>
              </TableRow>
              <TableRow>
                <TableGroup>
                  <TableLeftTitle>
                    결제
                    <WordSkip />
                    (카드번호)
                  </TableLeftTitle>
                  <RightRowFrame style={{ gap: "8px" }}>
                    <TextInfut value={num1} type="text" onChange={(e) => { setNum1(e.target.value.replace(/\D/g, '')) }} maxLength="4" placeholder="- - - -"></TextInfut>
                    <TextInfut value={num2} type="password" onChange={(e) => { setNum2(e.target.value.replace(/\D/g, '')) }} maxLength="4" placeholder="- - - -"></TextInfut>
                    <TextInfut value={num3} type="password" onChange={(e) => { setNum3(e.target.value.replace(/\D/g, '')) }} maxLength="4" placeholder="- - - -"></TextInfut>
                    <TextInfut value={num4} type="text" onChange={(e) => { setNum4(e.target.value.replace(/\D/g, '')) }} maxLength="4" placeholder="- - - -"></TextInfut>
                  </RightRowFrame>
                </TableGroup>
                <TableGroup>
                  <TableLeftTitle>
                    결제
                    <WordSkip />
                    (유효기간)
                  </TableLeftTitle>
                  <RightRowFrame style={{ gap: "8px", alignItems: "center" }}>
                    <TextInfut value={mm} type="text" onChange={(e) => { setMm(e.target.value.replace(/\D/g, '')) }} maxLength="2" placeholder="mm"></TextInfut>
                    <TextInfut value={yy} type="text" onChange={(e) => { setYy(e.target.value.replace(/\D/g, '')) }} maxLength="2" placeholder="yy"></TextInfut>
                    <RightReguler>(월/년)</RightReguler>
                  </RightRowFrame>
                </TableGroup>
              </TableRow>
              <TableRow>
                <TableGroup style={{ width: "100%" }}>
                  <TableLeftTitle>특이사항</TableLeftTitle>
                  <TextArea onChange={(e) => { setMemo(e.target.value) }} placeholder="기타 전달 사항을 입력해 주세요."></TextArea>
                </TableGroup>
              </TableRow>
            </TableFrame>
          </SubContentFrame>
          <ButtonLine>
            <ButtonBack onClick={() => {
              dispatch(PDorderAssignType({ pickAndDeli: PD === 2 ? 2 : 0, pickup: PD === 2 ? 2 : data.assignType, deli: PD === 2 ? 2 : data.assignText }));
              navigate('/address');
            }}>이전</ButtonBack>
            <ButtonRed disable={disableBtn} onClick={() => { nextPage() }}>다음</ButtonRed>
          </ButtonLine>

        </>
      }
    </ContentFrame>
  );
}



// {
//   popup === true &&
//   <BackgroundBlack>
//     <PricePopup>
//       <SubTitle>공임나라 x YWMobile 탁송 가격 안내</SubTitle>
//       <PopupWrapper>
//         <PopupText>기본 요금 (5Km 기준)</PopupText>
//         <DefaultPriceTable>
//           <tr>
//             <TableHead>차종</TableHead>
//             <TableHead>기본 요금</TableHead>
//             <TableHead>기본 운행 거리 <br />초과 요금</TableHead>
//           </tr>
//           <tr>
//             <TableData>국산차</TableData>
//             <TableData>18,000원</TableData>
//             <TableData>1,000원 / Km</TableData>
//           </tr>
//           <tr>
//             <TableData>수입차</TableData>
//             <TableData>20,000원</TableData>
//             <TableData>1,000원 / Km</TableData>
//           </tr>
//         </DefaultPriceTable>
//         <PopupText>부가 요금</PopupText>
//         <DefaultPriceTable>
//           <tr>
//             <TableHead style={{ height: '43px' }}>항목</TableHead>
//             <TableHead style={{ height: '43px' }}>기본 요금</TableHead>
//             <TableHead style={{ height: '43px' }}>비고</TableHead>
//           </tr>
//           <tr>
//             <TableData>대기</TableData>
//             <TableData>5,000 / 30분</TableData>
//             <TableData>-</TableData>
//           </tr>
//           <tr>
//             <TableData>경유</TableData>
//             <TableData>1,000 / Km</TableData>
//             <TableData>-</TableData>
//           </tr>
//           <tr>
//             <TableData>취소</TableData>
//             <TableData>10,000 / 건</TableData>
//             <TableData>기사 배차 후 취소시</TableData>
//           </tr>
//           <tr>
//             <TableData>배차 취약시간</TableData>
//             <TableData>5,000 / 건</TableData>
//             <TableData>출발시간 16:00 ~  익일 09:00</TableData>
//           </tr>
//           <tr>
//             <TableData>긴급  배차</TableData>
//             <TableData>10,000 / 건</TableData>
//             <TableData>3시간 이내 배차 요청</TableData>
//           </tr>
//           <tr>
//             <TableData>격오지</TableData>
//             <TableData>10,000 / 건</TableData>
//             <TableData>출발/도착지가 읍/면/리 인 경우</TableData>
//           </tr>
//           <tr>
//             <TableData>부가업무</TableData>
//             <TableData>10,000  / 건</TableData>
//             <TableData>서류 처리, 주유, 세차</TableData>
//           </tr>
//         </DefaultPriceTable>
//       </PopupWrapper>
//       <ButtonLine style={{ padding: "20px" }}>
//         <ButtonRed onClick={() => { setPopup(!popup) }}>닫기</ButtonRed>
//       </ButtonLine>
//     </PricePopup>
//   </BackgroundBlack>
// }







//
//
// <TableRow>
//   <TableGroup>
//     <LeftColFrame>
//       <TableLeftTitle>요금</TableLeftTitle>
//       <RightRegulerMini
//           style={{ color: "#333", textDecorationLine: "underline", cursor: 'pointer' }}
//           onClick={() => { setPopup(!popup) }}
//       >
//         전체 요금 안내
//       </RightRegulerMini>
//     </LeftColFrame>
//     <RightColFrame>
//       <RightRowFrame style={{ gap: "10px", alignItems: "flex-end" }}>
//         <RightMedium>총 결제 금액</RightMedium>
//         <RightRowFrame style={{ alignItems: "flex-end" }}>
//           <PayTitle style={{ marginBottom: "-5px" }}>
//             {
//               replacePrice(((systemPrice + pdSystemPrice) + (emergency + pdEmergency) + (outBack + pdOutBack) + (danger + pdDanger)))
//             }
//           </PayTitle>
//           <RightMedium>원</RightMedium>
//         </RightRowFrame>
//       </RightRowFrame>
//       <RedTitle>
//         대기/경유/취소/부가서비스가 발생시
//         <br /> 추가 요금이 발생 될 수 있습니다.
//       </RedTitle>
//     </RightColFrame>
//   </TableGroup>
//   <TableGroup>
//     <TableLeftTitle>
//       요금 <WordSkip />
//       상세내역
//     </TableLeftTitle>
//     <RightColFrame>
//       <RightRowFrame>
//         <RightMedium86px style={{ marginBottom: "4px" }}>
//           기본 요금
//         </RightMedium86px>
//         <RightReguler>{replacePrice(systemPrice + pdSystemPrice)}원</RightReguler>
//       </RightRowFrame>
//       <RightRowFrame>
//         <RightMedium86px style={{ marginBottom: "4px" }}>
//           긴급 배차
//         </RightMedium86px>
//         <RightColFrameMini>
//           <RightReguler>
//             {replacePrice(emergency + pdEmergency)}원
//           </RightReguler>
//           <RightRegulerMini>
//             접수시간 기준 3시간 이내 배차 요청
//           </RightRegulerMini>
//         </RightColFrameMini>
//       </RightRowFrame>
//       <RightRowFrame>
//         <RightMedium86px style={{ marginBottom: "4px" }}>
//           오지 요금
//         </RightMedium86px>
//         <RightColFrameMini>
//           <RightReguler>
//             {replacePrice(outBack + pdOutBack)}원
//           </RightReguler>
//           <RightRegulerMini>
//             출발지/도착지가 읍/면/리일 경우
//           </RightRegulerMini>
//         </RightColFrameMini>
//       </RightRowFrame>
//       <RightRowFrame>
//         <RightMedium86px style={{ marginBottom: "4px" }}>
//           배차
//           <br />
//           취약시간
//         </RightMedium86px>
//         <RightColFrameMini>
//           <RightReguler>
//             {replacePrice(danger + pdDanger)}원
//           </RightReguler>
//           <RightRegulerMini>
//             출발시간 기준 16:00 ~ 09:00
//           </RightRegulerMini>
//         </RightColFrameMini>
//       </RightRowFrame>
//     </RightColFrame>
//   </TableGroup>
// </TableRow>